import React from "react";
//import User from "@assets/images/icons/user.svg";
import Mode from "@components/layout/Header/components/Mode";
import MobileAuthHeader from "@components/layout/Header/components/MobileAuthHeader";
import UserProfileDropdown from "@components/layout/Header/components/UserProfileDropdown";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "@helpers/translate";
import { useDispatch, useSelector } from "react-redux";
import { AUTH } from "@constants";
import { Button } from "@components/library";
import LanguageDropdown from "@components/layout/Header/components/LanguageDropdown";
import "./Authorized.sass";

const Authorized = ({ sidebarToggle }) => {
  const isDesktop = useMediaQuery("(min-width:1000px)");
  const { __ } = useTranslation();
  const { isDemoUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  if (!isDesktop) return <MobileAuthHeader sidebarToggle={sidebarToggle} />;

  const openAuthPopup = () => {
    dispatch({ type: AUTH.AUTH_CHANGE_POPUP, payload: true });
  };

  return (
    <div className="header__right">
      <ul className="header__nav-list">
        {/* Trading кнопка - закоментована */}
        {/*<li className="header__nav-item">
          <Button
            type="link"
            className="header__trading header__btn"
            to="/"
            color="orange"
            size="mini"
          >
            {__('common.trading')}
          </Button>
        </li>*/}

        {/* Депозит кнопка */}
        <li className="header__nav-item">
          {isDemoUser ? (
            <Button
              type="button"
              onClick={openAuthPopup}
              className="header__deposit"
              color="orange"
              size="mini"
            >
              {__("common.deposit_header_btn")}
            </Button>
          ) : (
            <Button
              type="link"
              className="header__deposit"
              to="/wallet/deposit"
              color="orange"
              size="mini"
            >
              {__("common.deposit_header_btn")}
            </Button>
          )}
        </li>

        {/* Рахунок */}
        <li className="header__nav-item">
          <Mode />
        </li>

        {/* Мова (лише demo — у звичайного акаунта в UserProfileDropdown) */}
        {isDemoUser && (
          <li className="header__nav-item">
            <LanguageDropdown variant="header" />
          </li>
        )}

        {/* Профіль */}
        <li className="header__nav-item">
          {isDemoUser ? (
            <button
              onClick={openAuthPopup}
              type="button"
              className="header__mini-btn"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 15.75V14.25C15 13.4544 14.6839 12.6913 14.1213 12.1287C13.5587 11.5661 12.7956 11.25 12 11.25H6C5.20435 11.25 4.44129 11.5661 3.87868 12.1287C3.31607 12.6913 3 13.4544 3 14.25V15.75"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          ) : (
            <UserProfileDropdown />
          )}
        </li>
      </ul>
    </div>
  );
};

export default Authorized;
